import React, { useContext, useEffect, useMemo, useState } from 'react'

import { Input, Modal } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import RejectionReasonsTabs, { OTHER_REJECTION_REASON } from '../../../../Components/shared/InternshipsManager/RejectionReasonsTabs'
import '../../../../assets/shared/modal-inner-container.scss'

const { TextArea } = Input

const REFUSAL_REASON_MAX_LENGTH = 500

const InternshipRequestRefusalModal = ({ loading = false, visible = false, withRejectionReasons = false, onCancel, onConfirm }) => {
  const ic = useContext(InstitutionContext)
  const t = useSelector(selectTranslate)

  const [refusalReason, setRefusalReason] = useState('')
  const [selectedReason, setSelectedReason] = useState(OTHER_REJECTION_REASON)

  useEffect(() => {
    if (!visible) {
      setRefusalReason('')
      setSelectedReason(OTHER_REJECTION_REASON)
    }
  }, [visible])

  const resolvedReason = useMemo(() => {
    if (withRejectionReasons && selectedReason !== OTHER_REJECTION_REASON) {
      return ic?.rejectionReasons?.find(rr => rr.id === selectedReason)?.name ?? ''
    }

    return refusalReason.trim()
  }, [withRejectionReasons, selectedReason, refusalReason, ic?.rejectionReasons])

  return (
    <Modal
      visible={visible}
      title={t('internship_requests_table.actions.refuse_title')}
      onCancel={onCancel}
      onOk={() => onConfirm(resolvedReason)}
      okText={t('common.refuse')}
      okType='danger'
      okButtonProps={{ disabled: resolvedReason === '' }}
      cancelText={t('common.cancel')}
      confirmLoading={loading}
      destroyOnClose
      centered
    >
      <div className='modal-inner-container warning'>
        {t('internship_requests_table.actions.refuse_content')}
      </div>
      <div className='mt-16'>
        {withRejectionReasons
          ? (
            <RejectionReasonsTabs
              selectedReason={selectedReason}
              comment={refusalReason}
              commentMaxLength={REFUSAL_REASON_MAX_LENGTH}
              onSelectedReasonChange={setSelectedReason}
              onCommentChange={setRefusalReason}
            />
          )
          : (
            <TextArea
              maxLength={REFUSAL_REASON_MAX_LENGTH}
              rows={4}
              value={refusalReason}
              placeholder={t('internship_requests_table.actions.refuse_reason_placeholder')}
              onChange={event => setRefusalReason(event.target.value)}
            />
          )}
      </div>
    </Modal>
  )
}

export default InternshipRequestRefusalModal
